import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from 'src/app/services/environment/environment.service';

export interface SmartSampleResult {
  start_row:        number;
  end_row:          number;
  row_count:        number;
  variety_pct:      number;
  total_patterns:   number;
  window_patterns:  number;
  sort_field:       string | null;
  sort_method:      string;
  sort_description: string;
  total_rows:       number;
  warnings:         string[];
  elapsed_s:        number;
  cached:           boolean;
  target_variety_pct?:   number;
  below_min_farm_size?:  boolean;
  error?:           string;
}

@Injectable({ providedIn: 'root' })
export class IntelligenceService {
  constructor(
    private http: HttpClient,
    private envService: EnvironmentService,
  ) {}

  private get baseUrl(): string {
    return (this.envService.activeEngineBaseUrl ?? '') + '/api/v1.0/intelligence';
  }

  getSmartSample(inputCacheKey: string, sourceColumn: string, smartSampleMode: number = 0): Observable<SmartSampleResult> {
    return this.http.post<SmartSampleResult>(`${this.baseUrl}/smart-sample`, {
      inputCacheKey,
      sourceColumn,
      smartSampleMode,
    });
  }
}
